import PropTypes from 'prop-types'
import { Input, Form } from 'antd'

const components = {
  search: Input.Search,
  password: Input.Password,
  textarea: Input.TextArea,
  default: Input,
}

const InputText = (props) => {
  const {
    label,
    name,
    placeholder,
    type,
    className = '',
    initialValue = '',
    style = null,
    maxLength = undefined,
    wrapperClass = '',
    pattern = undefined,
    isRequired = true,
    readOnly = false,
    hideLabel = false,
    disabled = false,
    onChange = () => {},
    onSubmit,
    errorHelp = false,
    errorMsg = '',
  } = props
  const Tag = components[type] || components.default

  return (
    <Form.Item
      name={name}
      label={label ? label : ''}
      initialValue={initialValue}
      className={`${wrapperClass} ${hideLabel ? 'hide-label' : ''}`}
      style={{ marginBottom: 0 }}
      rules={
        isRequired
          ? [
              {
                required: true,
                message:
                  errorHelp === false
                    ? ''
                    : errorMsg.length > 0
                      ? errorMsg
                      : `Please enter "${label}"`,
              },
            ]
          : undefined
      }
      {...(errorHelp === false ? { help: '' } : {})}
    >
      <Tag
        key={name}
        type={type}
        placeholder={placeholder ? placeholder : label}
        aria-label={label ? label : placeholder}
        readOnly={readOnly}
        disabled={disabled}
        pattern={pattern}
        maxLength={maxLength}
        className={className}
        autoComplete="off"
        {...(style ? { style: style } : {})}
        onChange={(e) => {
          onChange(e.target.value)
        }}
        {...(type === 'search' && onSubmit && { onSearch: (e) => onSubmit(e) })}
      />
    </Form.Item>
  )
}

InputText.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string.isRequired,
  className: PropTypes.string,
  initialValue: PropTypes.string,
  style: PropTypes.object,
  maxLength: PropTypes.number,
  wrapperClass: PropTypes.string,
  pattern: PropTypes.string,
  isRequired: PropTypes.bool,
  readOnly: PropTypes.bool,
  hideLabel: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  errorHelp: PropTypes.bool,
  errorMsg: PropTypes.string,
}

export default InputText
